import '../scss/event-slider.scss';
import '../scss/slider.scss';
import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import '@splidejs/splide/css/core';

const sliderList = document.querySelectorAll('[data-event-slider]');
document.addEventListener('DOMContentLoaded', function () {

  sliderList.forEach((sliderEl) => {
    new Splide(sliderEl, {
      arrows: true,
      classes: {
        pagination: 'c-event-slider__pagination',
        page: 'c-event-slider-pagination__page',
      },
      keyboard: true,
      padding: {
        right: '15%',
      },
      perPage: 2,
      gap: '2rem',
      rewind: true,
      breakpoints: {
        576: {
          padding: {
            right: '0',
          },
          perPage: 1
        }
      }
    }).on('pagination:mounted', function (data) {
      data.list.classList.add('splide__pagination--events');
      const totalEvents = data.items.length;
      data.items.forEach(function (item) {
        item.button.textContent = `${item.page + 1}/${totalEvents}`;
      });
    }).mount();
  });
});
